import React, { useEffect, useRef } from 'react';
import { Container, Graphics } from '@pixi/react';

import { Spine } from '../../core/classes/spine';
import { isMobile } from '../../core/helpers/isMobile';

import { userInfoStore } from '../../store/userInfoStore';

import { gameResourcesService } from '../../services/gameResourcesService';

import MenuWrapper from '../../containers/common/menuWrapper';
import Notification from '../../containers/common/notification';
import MobileFooterContainer from '../../containers/mobile/footer';
import WinLineWrapper from '../../containers/common/winLineWrapper';
import FreeBetWrapper from '../../containers/common/freeBetWrapper';
import GameLogoWrapper from '../../containers/common/gameLogoWrapper';
import WinPopupWrapper from '../../containers/common/winPopupWrapper';
import InfoSectionContainer from '../../containers/common/infoWrapper';
import GameBoardWrapper from '../../containers/common/gameBoardWrapper';
import LobbyIconWrapper from '../../containers/common/lobbyIconWrapper';
import ExpandWildWrapper from '../../containers/common/expandWildWrapper';
import JackPotInfoWrapper from '../../containers/common/jackPotInfoWrapper';
import GameBackgroundWrapper from '../../containers/common/gameBackgroundWrapper';
import TournamentIconWrapper from '../../containers/common/tournamentIconWrapper';
import ConnectionPopupWrapper from '../../containers/common/connectionPopupWrapper';

import Gamble from '../../components/common/gamble';
import JackpotScene from '../../components/common/jackpotScene';
import ScaleComponent from '../../components/mobile/scaleComponent';
import MobileGameLayer from '../../components/mobile/mobileGameLayer';
import MobileBigWinLayer from '../../components/mobile/mobileBigWinLayer';
import JackPotCongratsPopup from '../../components/common/jackpot/jackPotCongratsPopup';
import BoostedJackpot from '../../components/common/boostedJackpot';
import BoostedJackpotIcon from '../../components/common/boostedJackpotIcon';
import RePlayInfoIconWrapper from "../../containers/common/rePlayInfoIconWrapper";

function MobileView({ setMask, reelContainerRef, winContainerRef, reelContainerConfig }) {
  const gameSceneShakeSpineRef = useRef(null);
  const shakeContainerRef = useRef(null);

  useEffect(() => {
    const gameSceneShakeSpine = new Spine({ key: 'shake' });
    gameSceneShakeSpine.x = isMobile() ? -6 : 0;
    gameSceneShakeSpine.y = 0;
    gameResourcesService.setShakeSpine(gameSceneShakeSpine);
    gameSceneShakeSpine.addChildToSlot('shake', shakeContainerRef.current);
    gameSceneShakeSpineRef.current.addChild(gameSceneShakeSpine);
  }, []);

  return (
    <>
      <GameBackgroundWrapper />
      <ScaleComponent isCenterHorizontal>
        <Container ref={gameSceneShakeSpineRef} name='GameSceneShakeContainer'>
          <Container ref={shakeContainerRef}>
            <GameBoardWrapper />
            <GameLogoWrapper />
            <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
              <Graphics
                draw={(g) => {
                  g.beginFill(0xff700b);
                  g.drawRect(-50, -35, 495, 296);
                }}
                ref={(graphicsRef) => setMask(graphicsRef)}
              />
            </Container>
          </Container>
        </Container>
        <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
        <ExpandWildWrapper />
        <WinLineWrapper />
      </ScaleComponent>
      <MobileBigWinLayer />
      <ScaleComponent isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 520, 1);
          }}
        />
        <WinPopupWrapper />
        <MobileFooterContainer />
        <TournamentIconWrapper />
        <Notification />
        <RePlayInfoIconWrapper />
      </ScaleComponent>
      <LobbyIconWrapper />
      <ScaleComponent isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <BoostedJackpotIcon />
      </ScaleComponent>
      <ScaleComponent name='GameTopLayers' isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />

        <JackPotInfoWrapper />
      </ScaleComponent>
      <MobileGameLayer />
      <ScaleComponent name='GameTopLayers' isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <FreeBetWrapper />
        <InfoSectionContainer />
        <MenuWrapper />
        <Gamble />
        <BoostedJackpot />
      </ScaleComponent>
      <JackPotCongratsPopup />
      <JackpotScene />
      <ConnectionPopupWrapper />
    </>
  );
}

export default MobileView;
